var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___cHN2cU",
  "gs": "ChannelMessages.module__scrollerContainer___cHN2cU",
  "gT": "ChannelMessages.module__scrollerContent___cHN2cU",
  "lB": "ChannelMessages.module__scrollerSpacer___cHN2cU",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___cHN2cU",
  "pi": "ChannelMessages.module__fillerBuffer___cHN2cU",
  "CU": "ChannelMessages.module__groupSpacer___cHN2cU",
  "$P": "ChannelMessages.module__groupSpacerHalf___cHN2cU",
  "bv": "ChannelMessages.module__scrollerInner___cHN2cU",
  "eb": "ChannelMessages.module__newMessagesBar___cHN2cU",
  "mC": "ChannelMessages.module__newMessagesBarBanner___cHN2cU",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___cHN2cU",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___cHN2cU",
  "G6": "ChannelMessages.module__messageBottomPill___cHN2cU",
  "Sg": "ChannelMessages.module__jumpToPresentBar___cHN2cU",
  "RQ": "ChannelMessages.module__newMessagesBarText___cHN2cU",
  "As": "ChannelMessages.module__loadErrorBar___cHN2cU",
  "Ku": "ChannelMessages.module__newMessagesBarAction___cHN2cU",
  "WB": "ChannelMessages.module__unreadSlot___cHN2cU",
};

module.exports = exports;
